import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getChatPayloadData, getIsChatTyping } from '../../../../redux/chat/selectors';
import { styles } from './styles';
import { IconButton } from '../../IconButton';
import { useMessageInput } from './useMessageInput';
import User, { isValidAiApiKey } from '../../../../tools/user';

const MessageInput = ({
  value,
  setValue,
  handleSendMessage,
  reportId,
  chatId,
}) => {
  const isTyping = useSelector(getIsChatTyping);
  const payloadData = useSelector(getChatPayloadData(reportId));
  const { handleKeyPress, handleChange } = useMessageInput(
    setValue,
    value,
    handleSendMessage,
    chatId,
  );

  const user = User.getUserInfo();
  const hasApiKey = isValidAiApiKey(user);
  if (!hasApiKey) return null;

  const handleClick = () => {
    if (value && value.trim()) {
      handleSendMessage(value);
      setValue('');
    }
  };

  return (
    <div style={styles.wrapper}>
      <textarea
        style={styles.input}
        required
        placeholder="Type your question ..."
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyPress}
      />
      <div style={{ display: 'flex', marginTop: 'auto' }}>
        <IconButton
          onClick={handleClick}
          color="secondary"
          disabled={isTyping || !payloadData}
        />
      </div>
    </div>
  );
};


MessageInput.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  handleSendMessage: PropTypes.func.isRequired,
  reportId: PropTypes.string.isRequired,
  chatId: PropTypes.number.isRequired,
};

export default MessageInput;
